const charmCustomizerConfig = window.__jewelryCharmCustomizerConfig || {};

let productDetail = charmCustomizerConfig.productDetail || {};
let productVariants = charmCustomizerConfig.productVariants || [];
let metaValues = charmCustomizerConfig.metaValues || {};
const productFormSelector = charmCustomizerConfig.productFormSelector;

function getCharmProductForm() {
	if (!productFormSelector) return null;
	let form = document.querySelector(productFormSelector);
	if (form) return form;
	return document.querySelector('form[action*="/cart/add"]');
}
const shopifyCartUrl = charmCustomizerConfig.shopifyCartUrl;
const shopUrl = charmCustomizerConfig.shopUrl;
const photoGuideAssetUrl = charmCustomizerConfig.photoGuideAssetUrl;

const slidePages = document.querySelectorAll(".slide-page");
const stepsLines = document.querySelectorAll(".progressbar .progress-line");
let totalPages = document.querySelector(".totalPages");
let current = 1;
let brokenNativeVariant = {};
let formattedVariant = {};
let brokenVariantString = "";
let galleryImageValue = {};
let brokenValues = getBrokenValues();
let nativeValues = getNativeValues();
formattedVariant = { ...formattedVariant, ...nativeValues };
let currentFinish = "gold";

const charmApiDetails = charmCustomizerConfig?.apiDetails || [];
if (metaValues) {
	metaValues?.steps?.forEach((step) => {
		const imageChangeCheck = step.gallery_image_change;

		if (imageChangeCheck) {
			galleryImageValue[step.step_name.toLowerCase().replace(/\s+/g, "")] = "";
		}
		if (step.gallery_image_change_on_options) {
			step.swatches.forEach((swatchOption) => {
				if (swatchOption.gallery_image_change) {
					galleryImageValue[swatchOption.name.toLowerCase()] = "";
				}
			});
		}
	});
}

if (Object.keys(galleryImageValue) && Object.keys(formattedVariant)) {
	updateGalleryImageValueForBrokenValues(formattedVariant);
}

function updateGalleryImageValueForBrokenValues(formattedVariantData) {
	for (const [key, value] of Object.entries(formattedVariantData)) {
		if (Object.prototype.hasOwnProperty.call(galleryImageValue, key)) {
			galleryImageValue[key] = value;
		}
	}
	handleImageSlider();
}

for (const [key, value] of Object.entries(galleryImageValue)) {
	if (value === "") {
		const getKeyHiddenInput = document.querySelector(`.${key}HiddenInput`);
		if (getKeyHiddenInput) {
			galleryImageValue[key] = getKeyHiddenInput.value;
		}
	}
}
handleImageSlider();

let finalVariantValue = `${Object.values(formattedVariant).join(" / ")}`;

validatePrice(finalVariantValue);

document.addEventListener("DOMContentLoaded", () => {
	setTimeout(() => {
		productVariants.forEach((variant) => {
			if (finalVariantValue == variant.title) {
				updatePriceContainer(variant);
			}
		});
	}, 5000);

	totalPages.innerHTML = current + " / " + slidePages.length;

	// INT-1783496569: the customizer never submits natively (steps advance via JS,
	// add-to-cart is AJAX). Block native form submission so pressing Enter in a
	// field (e.g. Pet Age) can never implicitly submit the form or skip mandatory
	// fields. Step buttons are type="button"; this closes any remaining edge case.
	const charmForm = getCharmProductForm();
	if (charmForm) {
		charmForm.addEventListener("submit", (submitEvent) => {
			submitEvent.preventDefault();
		});
	}
});

var itemsArray = [];

let extraOptions = document.querySelectorAll(".extraOption");

function updateSlidePosition() {
	slidePages.forEach((page, index) => {
		if (index === current - 1) {
			page.classList.add("active");
		} else {
			page.classList.remove("active");
		}
	});
}

function getBrokenValues() {
	let hiddenInputs = document.querySelectorAll(".defaultCheckbox");

	hiddenInputs.forEach((input) => {
		let className = Array.from(input.classList).find((c) =>
			c.endsWith("HiddenInput"),
		);
		if (className) {
			let key = className.replace("HiddenInput", "");
			brokenNativeVariant[key] = input.value;
		}
	});
	brokenVariantString = Object.values(brokenNativeVariant).join(" ");
	return brokenNativeVariant;
}

function getNativeValues() {
	let hiddenInputs = document.querySelectorAll(".nativeHiddenInputs");
	hiddenInputs.forEach((input) => {
		let className = Array.from(input.classList).find((c) =>
			c.endsWith("HiddenInput"),
		);

		if (className) {
			let key = className.replace("HiddenInput", "");
			formattedVariant[key] = formattedVariant[key]
				? formattedVariant[key] + " / " + input.value
				: input.value;
		}
	});

	for (let key in formattedVariant) {
		if (formattedVariant[key] === "") {
			formattedVariant[key] = brokenVariantString;
		}
	}
	return formattedVariant;
}

function selectSwatch(
	name,
	sku,
	optionLabel,
	value,
	currentImage,
	swatchIndex,
	isNative,
	identifier,
	isUploader,
	isTextInput,
) {
	let imageUploaderContainer = document.querySelector(".multi-image-uploader");
	let wrapperEl = document.querySelector(".Pet-name-input-wrapper");
	let swatchHiddenInput;
	let skuHiddenInput;
	if (optionLabel === "") {
		swatchHiddenInput = document.querySelector(
			`.${name}HiddenInput_${swatchIndex}`,
		);
		skuHiddenInput = document.querySelector(
			`.${name}_cors_HiddenInput_${swatchIndex}`,
		);
	} else {
		swatchHiddenInput = document.querySelector(`.${optionLabel}HiddenInput`);
		skuHiddenInput = document.querySelector(`.${optionLabel}_cors_HiddenInput`);
	}
	swatchHiddenInput.value = "";
	swatchHiddenInput.value = value;
	skuHiddenInput.value = "";
	skuHiddenInput.value = sku;
	const swatchImages = document.querySelectorAll(
		`._${name}SwatchImages_${swatchIndex}`,
	);
	swatchImages.forEach((img) => {
		img.style.border = "none";
	});
	currentImage.style.border = "2px solid black";

	if (isNative) {
		if (optionLabel === "") {
			updateVariantTitle(name, value);
		} else {
			updateVariantTitle(optionLabel, value);
		}

		const hiddenInputs = document.querySelectorAll(`.${name}HiddenInput`);
		if (hiddenInputs.length > 0) {
			formattedVariant[name] = "";
			hiddenInputs.forEach((input) => {
				formattedVariant[name] = formattedVariant[name]
					? formattedVariant[name] + " / " + input.value
					: input.value;
			});
		}
	}
	validatePrice(finalVariantValue);
	if (optionLabel === "") {
		handleGalleryImageSlider(name, value);
	} else {
		handleGalleryImageSlider(optionLabel, value);
	}
	const UploaderContainers = document.querySelectorAll(".multi-image-uploader");
	if (isUploader) {
		imageUploaderContainer.innerHTML = "";

		UploaderContainers.forEach((container) => {
			container.style.marginTop = "2.5rem";
		});

		if (wrapperEl) {
			wrapperEl.innerHTML = "";
			let formPetName = document.querySelector(".form-field #Pet_Name");
			if (formPetName) {
				formPetName.dataset.skipValidation = "false";
				formPetName.style.pointerEvents = "auto";
				formPetName.style.opacity = "1";
				validateCharmHiddenInputs("customcard", "Pet_Name", "form", null, null);
			}
		}
		createImagesUploaders(swatchIndex, name);
		appendPhotoGuide();
	}

	if (isTextInput) {
		const container = document.querySelector(".photoGuideContainerMobile");
		if (imageUploaderContainer) {
			imageUploaderContainer.innerHTML = "";
			UploaderContainers.forEach((item) => {
				item.style.marginTop = "0.5rem";
			});
		}
		if (container) {
			container.innerHTML = "";
			container.style.margin = "0px";
		}
		wrapperEl.innerHTML = "";
		appendPetNameInput(
			wrapperEl,
			value,
			name,
			identifier,
			isTextInput,
			isUploader,
		);
	}

	validateCharmHiddenInputs(name, value, identifier, isTextInput, isUploader);

	if (name === "finish") {
		currentFinish = value.toLowerCase();
		updateAllSwatches(currentFinish);
	}
}

function updateAllSwatches(finish) {
	const charmOptions = document.querySelectorAll(".charmOption img");
	const swatches = document.querySelectorAll(".swatchImage");
	swatches.forEach((swatch) => {
		const goldImg = swatch.dataset.imageGold;
		const silverImg = swatch.dataset.imageSilver;
		if (finish.includes("silver")) {
			if (silverImg) {
				swatch.src = silverImg;
			}
		} else if (goldImg) {
			swatch.src = goldImg;
		}
	});

	charmOptions.forEach((charm) => {
		const goldImg = charm.dataset.imageGold;
		const silverImg = charm.dataset.imageSilver;
		const parentDiv = charm.closest(".charmOption");

		if (finish.includes("silver")) {
			if (silverImg) {
				charm.src = silverImg;
				if (parentDiv) parentDiv.dataset.charmimg = silverImg;
			}
		} else if (goldImg) {
			charm.src = goldImg;
			if (parentDiv) parentDiv.dataset.charmimg = goldImg;
		}
	});

	selectedCharms.forEach((c) => {
		const option = findCharmInMeta(c.name);
		if (option) {
			c.img =
				finish.includes("silver") && option.img_2 ? option.img_2 : option.img;
		}
	});
}

function findCharmInMeta(name) {
	const pillsStep = metaValues?.steps?.find((s) => s.identifier === "pills");
	if (!pillsStep || !pillsStep.pills) return null;
	const charmsData = pillsStep.pills[0];
	for (const tab in charmsData.tabs) {
		const found = charmsData.tabs[tab].find((c) => c.name === name);
		if (found) return found;
	}
	return null;
}

function handleGalleryImageSlider(key, value) {
	if (Object.prototype.hasOwnProperty.call(galleryImageValue, key)) {
		galleryImageValue[key] = value;
	}
	handleImageSlider();
}

function createImagesUploaders(i, stepname) {
	let imageUploaderContainer = document.querySelector(".multi-image-uploader");
	stepname = imageUploaderContainer.getAttribute("data-value");
	const uploaderSection = document.createElement("div");
	uploaderSection.classList.add(`uploaderSection-${i}`, "uploaderSection");

	const imageUploaderDiv = document.createElement("div");
	imageUploaderDiv.classList.add("image-uploader");
	imageUploaderDiv.setAttribute("id", "image-uploader-" + i);

	const closeButton = document.createElement("button");
	closeButton.classList.add("close-button-" + i, "close-button-simple");
	closeButton.setAttribute("type", "button");
	closeButton.textContent = "✖";

	const selectedImageContainer = document.createElement("div");
	selectedImageContainer.classList.add(
		"selected-image-" + i,
		"selected-image-container-simple",
	);

	const hiddenInput = document.createElement("input");
	hiddenInput.setAttribute("type", "hidden");
	hiddenInput.setAttribute("name", `properties[_image_url_${i}]`);
	hiddenInput.setAttribute("value", "");
	hiddenInput.setAttribute(
		"id",
		`hiddenInputSimple-${i} hiddenInputImage_${i}`,
	);
	hiddenInput.setAttribute(
		"class",
		`customHiddenInputs hiddenInputSimple-${i} hiddenInputImage`,
	);

	const uploadOuterDiv = document.createElement("div");
	uploadOuterDiv.classList.add("uploadOuter-" + i, "uploadOuter");

	const fileInput = document.createElement("input");
	fileInput.classList.add(`image_uploader_${i}`, "fileInput");
	fileInput.setAttribute("onclick", "this.value=null");
	fileInput.setAttribute("type", "file");
	fileInput.setAttribute("id", "uploadFile-" + i);
	fileInput.setAttribute(
		"onchange",
		`portraitDragNdrop(event, 'image-uploader-${i}', ${i}, '${stepname}', 1)`,
	);
	fileInput.setAttribute("ondragover", "drag(event)");
	fileInput.setAttribute("ondrop", "drop(event)");

	const uploadFileLabel = document.createElement("label");
	uploadFileLabel.classList.add("charm-upload-btn");
	uploadFileLabel.setAttribute("for", "uploadFile-" + i);
	uploadFileLabel.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="20" viewBox="0 0 24 20" fill="none"> <mask id="mask0_63_877" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24"> <rect width="24" height="24" fill="#D9D9D9"></rect></mask> <g mask="url(#mask0_63_877)"> <path d="M11 20H6.5C4.98333 20 3.6875 19.475 2.6125 18.425C1.5375 17.375 1 16.0917 1 14.575C1 13.275 1.39167 12.1167 2.175 11.1C2.95833 10.0833 3.98333 9.43333 5.25 9.15C5.66667 7.61667 6.5 6.375 7.75 5.425C9 4.475 10.4167 4 12 4C13.95 4 15.6042 4.67917 16.9625 6.0375C18.3208 7.39583 19 9.05 19 11C20.15 11.1333 21.1042 11.6292 21.8625 12.4875C22.6208 13.3458 23 14.35 23 15.5C23 16.75 22.5625 17.8125 21.6875 18.6875C20.8125 19.5625 19.75 20 18.5 20H13V12.85L14.6 14.4L16 13L12 9L8 13L9.4 14.4L11 12.85V20Z" fill="#5562C8"></path></g>
</svg><span>Upload Picture</span>`;

	uploadOuterDiv.appendChild(fileInput);
	uploadOuterDiv.appendChild(uploadFileLabel);

	imageUploaderDiv.appendChild(closeButton);
	imageUploaderDiv.appendChild(selectedImageContainer);
	imageUploaderDiv.appendChild(hiddenInput);
	imageUploaderDiv.appendChild(uploadOuterDiv);

	uploaderSection.appendChild(imageUploaderDiv);
	imageUploaderContainer.appendChild(uploaderSection);
}

function updatePriceContainer(variant) {
	var priceDiv = document.querySelector(".originalPrice");
	let price;
	let formattedPrice;
	if (priceDiv) {
		price = variant.price / 100;
		formattedPrice = `$${price.toFixed(2)}`;
		priceDiv.textContent = formattedPrice;
	}

	const priceUIContainer = document.querySelector(".price-ui");
	const compareAtPriceDiv = priceUIContainer
		? priceUIContainer.querySelector(".sizeChartBox .compare-at-price")
		: null;
	let compareAtPrice;
	let formattedComparePrice;
	if (compareAtPriceDiv) {
		compareAtPrice = variant.compare_at_price / 100;
		if (compareAtPrice > 0) {
			formattedComparePrice = `$${compareAtPrice.toFixed(2)}`;
			compareAtPriceDiv.innerHTML = "";
			compareAtPriceDiv.textContent = " " + formattedComparePrice;
		}
	}

	var pricePercentageContainer = document.querySelector(".pricePercentage");
	if (pricePercentageContainer) {
		pricePercentageContainer.textContent = "";
	}
	if (pricePercentageContainer && compareAtPrice > 0) {
		const content = document.createElement("p");
		var amountSaved = compareAtPrice - price;
		var discountPercentage = Math.floor((amountSaved / compareAtPrice) * 100);
		content.textContent = `You save: ${discountPercentage}% ($${amountSaved.toFixed(2)})`;
		const defaultPricePercentage = document.querySelector(
			".pricePercentageDefault",
		);
		if (defaultPricePercentage) {
			defaultPricePercentage.style.display = "none";
		}
		pricePercentageContainer.appendChild(content);
	}
}

function drag(e) {
	e.preventDefault();
}

function drop(e) {
	e.preventDefault();
}

async function portraitDragNdrop(
	event,
	containerId,
	number,
	buttonName,
	numberImages,
	swatchLabel,
) {
	const hiddenInput = document.querySelector(`.hiddenInputSimple-${number}`);
	const files = event.target.files;
	const totalUploaders = Number(numberImages) > 0 ? Number(numberImages) : 1;

	if (!hiddenInput) {
		return;
	}

	if (files.length > 1) {
		alert("Please select only one image file.");
		return;
	}

	const file = files[0];
	const ext = files[0].name.split(".").pop().toLowerCase();

	if (!file.type.startsWith("image/")) {
		if (ext !== "heic" && ext !== "heif") {
			alert("Please select only image files.");
			return;
		}
	}

	const allowedTypes = [
		"image/jpg",
		"image/png",
		"image/bmp",
		"image/jpeg",
		"image/heic",
		"image/heif",
	];
	if (!allowedTypes.includes(file.type)) {
		if (ext !== "heic" && ext !== "heif") {
			alert(
				"This type of image is not allowed. Please use only jpg, png, bmp, heic or heif.",
			);
			return;
		}
	}

	if (files[0].size > 15 * 1024 * 1024) {
		alert("Please select images smaller than 15MB.");
		return;
	}

	const previewImg = document.createElement("img");
	previewImg.src =
		"https://cdn.shopify.com/s/files/1/0537/2585/5916/files/Spinner-1s-200px.gif";

	const imageContainer = document.querySelector(`.selected-image-${number}`);
	const closeBtn = document.querySelector(`.close-button-${number}`);
	const uploaderBox = document.querySelector(`#image-uploader-${number}`);

	if (!imageContainer || !closeBtn || !uploaderBox) {
		return;
	}

	closeBtn.style.display = "block";
	uploaderBox.style.padding = "20px";

	imageContainer.innerHTML = "";
	imageContainer.style.position = "relative";

	previewImg.setAttribute("alt", "Image ");
	previewImg.setAttribute("id", "previewImageSimple");

	const progressWrapper = document.createElement("div");
	progressWrapper.className = "modern-progress-wrapper";
	progressWrapper.innerHTML = `
      <svg class="modern-progress-circle">
        <circle class="modern-bg" cx="22" cy="22" r="19.5"></circle>
        <circle class="modern-bar" cx="22" cy="22" r="19.5"></circle>
      </svg>
    `;

	const miniProgressWrapper = document.createElement("div");
	miniProgressWrapper.className = "mini-progress-wrapper";
	miniProgressWrapper.innerHTML = `
      <svg class="mini-progress-circle">
        <circle class="mini-bg" cx="12" cy="12" r="10.5"></circle>
        <circle class="mini-bar" cx="12" cy="12" r="10.5"></circle>
      </svg>
      <div class="mini-progress-text">0%</div>
    `;

	imageContainer.appendChild(progressWrapper);
	imageContainer.appendChild(miniProgressWrapper);
	imageContainer.appendChild(previewImg);

	const uploadOuter = document.querySelector(`.uploadOuter-${number}`);
	if (uploadOuter) uploadOuter.style.display = "none";
	uploaderBox.classList.add("has-image");

	const formData = new FormData();
	formData.append("image", files[0]);

	const xhr = new XMLHttpRequest();
	xhr.upload.addEventListener("progress", function (e) {
		if (e.lengthComputable) {
			const percent = Math.round((e.loaded / e.total) * 100);
			updateProgress(miniProgressWrapper, percent, "mini");
		}
	});

	xhr.onload = function () {
		if (progressWrapper.parentNode) progressWrapper.remove();
		if (miniProgressWrapper.parentNode) miniProgressWrapper.remove();

		const statusBadge = document.createElement("div");
		statusBadge.className = "upload-status-badge";
		imageContainer.appendChild(statusBadge);

		if (xhr.status === 200 || xhr.status === 201) {
			const data = JSON.parse(xhr.responseText);
			hiddenInput.value = data.imageUrl;

			const applyPreviewSize = () => {
				const containerWidth = 250;
				const containerHeight = 250;
				const nw = previewImg.naturalWidth;
				const nh = previewImg.naturalHeight;
				if (!nw || !nh) return;
				const imageAspectRatio = nw / nh;
				let imageWidth;
				let imageHeight;
				if (imageAspectRatio >= 1) {
					imageWidth = containerWidth;
					imageHeight = containerWidth / imageAspectRatio;
				} else {
					imageHeight = containerHeight;
					imageWidth = containerHeight * imageAspectRatio;
				}
				previewImg.style.width = `${imageWidth}px`;
				previewImg.style.height = `${imageHeight}px`;
				previewImg.style.objectFit = "contain";
			};

			previewImg.onload = applyPreviewSize;
			previewImg.src = data.imageUrl;
			if (previewImg.complete) applyPreviewSize();

			statusBadge.textContent = "Image Uploaded";
			statusBadge.classList.add("success");

			const imageUrl = data.imageUrl;
			const isAllImagesUploaded = validateAllUploaders(totalUploaders);
			showHideNextButton(buttonName, isAllImagesUploaded);
		} else {
			statusBadge.textContent = "Failed";
			statusBadge.classList.add("error");
		}
	};

	xhr.onerror = function () {
		if (progressWrapper.parentNode) progressWrapper.remove();
		if (miniProgressWrapper.parentNode) miniProgressWrapper.remove();

		const statusBadge = document.createElement("div");
		statusBadge.className = "upload-status-badge error";
		statusBadge.textContent = "Failed";
		imageContainer.appendChild(statusBadge);
	};

	const api = charmApiDetails[0];
	if (!api || !api.url) {
		if (progressWrapper.parentNode) progressWrapper.remove();
		if (miniProgressWrapper.parentNode) miniProgressWrapper.remove();
		return;
	}

	xhr.open("POST", `${api.url}image_uploader/print_image`);

	const headers = {
		"api-token": api.api_token,
		Authorization: `Bearer ${api.api_token}`,
	};
	Object.keys(headers).forEach((key) => {
		if (headers[key]) xhr.setRequestHeader(key, headers[key]);
	});

	xhr.send(formData);

	closeBtn.onclick = (e) => {
		e.preventDefault();
		imageContainer.innerHTML = "";
		const outer = document.querySelector(`.uploadOuter-${number}`);
		if (outer) outer.style.display = "block";
		closeBtn.style.display = "none";
		hiddenInput.value = "";
		uploaderBox.style.padding = "0px";
		uploaderBox.classList.remove("has-image");
		showHideNextButton(buttonName, false);
	};
}

function updateProgress(wrapper, percent, type = "modern") {
	const bar = wrapper.querySelector(
		type === "modern" ? ".modern-bar" : ".mini-bar",
	);
	const text = wrapper.querySelector(
		type === "modern" ? ".modern-progress-text" : ".mini-progress-text",
	);
	const radius = type === "modern" ? 19.5 : 10.5;
	const circumference = 2 * Math.PI * radius;
	const offset = circumference - (percent / 100) * circumference;

	if (bar) bar.style.strokeDashoffset = offset;

	if (text) {
		text.textContent = percent >= 100 ? "100%" : `${Math.round(percent)}%`;
	}
}

function showHideNextButton(buttonName, show) {
	const nextButton = document.querySelector(`.${buttonName}NextButton`);
	if (!nextButton) return;
	if (show) {
		nextButton.style.opacity = "1";
		nextButton.style.pointerEvents = "auto";
		nextButton.disabled = false;
	} else {
		nextButton.style.opacity = "0.3";
		nextButton.style.pointerEvents = "none";
		nextButton.disabled = true;
	}
}

function validateAllUploaders(total) {
	const need = Number(total) > 0 ? Number(total) : 1;
	const uploadedCount = document.querySelectorAll(
		".image-uploader.has-image",
	).length;
	return uploadedCount >= need;
}

function validatePrice(finalValue) {
	finalVariantValue = finalValue.trim();
	productVariants.forEach((variant) => {
		if (finalVariantValue === variant.title) {
			let priceDiv = document.querySelectorAll(".subTotalPrice");
			priceDiv.forEach((div) => {
				div.innerHTML = (variant.price / 100).toFixed(2);
			});
			const thumbnailImages = document.querySelectorAll(
				".product-gallery__thumbnail",
			);
			if (thumbnailImages) {
				thumbnailImages.forEach((image) => {
					const imageTitle = $(image).attr("data-title");

					if (imageTitle === finalVariantValue) {
						$(image).trigger("click");
						$(thumbnailImages).removeClass("is-nav-selected");
						$(image).addClass("is-nav-selected");
					}
				});
			}

			updatePriceContainer(variant);
		}
	});
}

function updateVariantTitle(stepName, value) {
	formattedVariant[stepName] = value;
	let updatedFinalVariantValue = Object.values(formattedVariant).join(" / ");
	validatePrice(updatedFinalVariantValue);
}

const MULTISTEP_SCROLL_OFFSET = 80;

function scrollToMultiStepContainer() {
	const el = document.querySelector(".multiStepContainer");
	if (!el) return;

	requestAnimationFrame(() => {
		const top =
			el.getBoundingClientRect().top +
			window.scrollY -
			MULTISTEP_SCROLL_OFFSET;
		window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
	});
}

function addEventListeners(stepName, index) {
	const nextBtn = document.querySelector(
		`.${stepName.toLowerCase().replace(/ /g, "")}NextButton`,
	);
	const prevBtn = document.querySelector(
		`.${stepName.toLowerCase().replace(/ /g, "")}PrevButton`,
	);

	if (nextBtn) {
		nextBtn.addEventListener("click", async function (eventClick) {
			eventClick.preventDefault();

			// Bug 9: block keyboard bypass of mandatory fields. When a step is
			// incomplete the validators mark the button invalid via
			// pointer-events:none / disabled (which only stop mouse clicks).
			// Enter on the focused button, or implicit form submit from Enter in a
			// field, still reaches this handler — so re-check the invalid state here
			// and refuse to advance.
			if (nextBtn.disabled || nextBtn.style.pointerEvents === "none") {
				return;
			}

			let extraOptionsList = document.querySelectorAll(".extraOption");
			let getHiddenInput = document.querySelector(
				`.${stepName.toLowerCase().replace(/ /g, "")}HiddenInput`,
			);
			let getHiddenInputValue;
			let isNativeElement;
			if (getHiddenInput && isNativeElement) {
				isNativeElement =
					Array.from(getHiddenInput?.classList).find((c) =>
						c.includes("nativeHiddenInputs"),
					) || false;
				if (isNativeElement) {
					getHiddenInputValue = getHiddenInput.value;
					getHiddenInputValue.replace(/"/g, '\\"');
				}
			}

			if (getHiddenInputValue) {
				formattedVariant[stepName.toLowerCase().replace(/ /g, "")] =
					getHiddenInputValue;
			}

			if (current < slidePages.length) {
				current += 1;
				updateSlidePosition();
				stepsLines[current - 1].classList.add("active");
				scrollToMultiStepContainer();
				totalPages.innerHTML = current + " / " + slidePages.length;
			} else {
				nextBtn.disabled = true;
				nextBtn.style.cssText =
					"opacity:0.3;pointer-events:none;cursor:not-allowed";
				const originalText = nextBtn.textContent;
				nextBtn.textContent = "Adding...";

				productVariants.forEach((variant) => {
					if (finalVariantValue == variant.title) {
						let variantIdInput = document.querySelector("#variantid");

						if (variantIdInput) {
							variantIdInput.value = variant.id;
						}

						const thumbnailImages = document.querySelectorAll(
							".product-gallery__thumbnail",
						);
						if (thumbnailImages) {
							thumbnailImages.forEach((image) => {
								const imageTitle = $(image).attr("data-title");

								if (imageTitle === finalVariantValue) {
									$(image).trigger("click");
									$(thumbnailImages).removeClass("is-nav-selected");
									$(image).addClass("is-nav-selected");
								}
							});
						}

						updatePriceContainer(variant);

						const finalvalues = finalVariantValue.split(" / ");
						finalvalues.forEach((value, itemIndex) => {
							const formattedOptions = productDetail.options.map((option) =>
								option.replace(/\s+/g, "_"),
							);
							const hiddenInput = document.createElement("input");
							hiddenInput.type = "hidden";
							hiddenInput.setAttribute(
								"name",
								`properties[_option_${formattedOptions[itemIndex]}]`,
							);
							hiddenInput.setAttribute("value", value);
							document
								.querySelector(productFormSelector)
								.appendChild(hiddenInput);
						});
						const customHiddenInputs = document.querySelectorAll(
							".customHiddenInputs",
						);

						if (customHiddenInputs) {
							customHiddenInputs.forEach((item) => {
								const hiddenInput = document.createElement("input");
								hiddenInput.type = "hidden";
								hiddenInput.setAttribute(
									"name",
									`properties[${item.getAttribute("data-name")}]`,
								);
								hiddenInput.setAttribute("value", item.value);
								document
									.querySelector(productFormSelector)
									.appendChild(hiddenInput);
							});
						}
					}
				});

				const relatedProductEl = document.querySelector("#relatedProduct");
				let uniqueKey = relatedProductEl ? relatedProductEl.value : "";
				// Ensure a non-empty linking key: if it was never initialized,
				// generate one now and write it back so the main line
				// (_original_unique_key, read from the form) stays in sync with the
				// add-on lines (_unique_key) below.
				if (relatedProductEl && !String(uniqueKey).trim()) {
					uniqueKey = String(Date.now());
					relatedProductEl.value = uniqueKey;
				}
				if (extraOptionsList) {
					extraOptionsList.forEach((option) => {
						if (option.checked) {
							var item = {
								quantity: 1,
								id: option.value,
								properties: {
									_unique_key: uniqueKey,
								},
							};
							itemsArray.push(item);
						}
					});
				}

				if (selectedCharms.length > 0) {
					selectedCharms.forEach((charm) => {
						var item = {
							quantity: 1,
							id: charm.id,
							properties: {
								_unique_key: uniqueKey,
								_is_Charm: "true",
							},
						};
						itemsArray.unshift(item);
					});
				}

				async function addToCart(items, cartUrl) {
					const formEl = getCharmProductForm();
					var formData = formEl ? $(formEl).serializeArray() : [];
					let mainItemId = null;

					const primaryProduct = formData.reduce((acc, { name, value }) => {
						const match = name.match(/^properties\[(.+?)\]$/);
						if (match) {
							const extractedName = match[1];

							if (acc[extractedName]) {
								if (Array.isArray(acc[extractedName])) {
									acc[extractedName].push(value);
								} else {
									acc[extractedName] = [acc[extractedName], value];
								}
							} else {
								acc[extractedName] = value;
							}
						} else if (name === "id") {
							mainItemId = value;
						}
						return acc;
					}, {});

					const mainItem = {
						quantity: 1,
						id: mainItemId,
						properties: { ...primaryProduct },
					};

					items.push(mainItem);

					const combinedItems = items.map((item) => ({
						quantity: 1,
						id: item.id,
						properties: item.properties || {},
					}));

					const combinedOptions = {
						method: "POST",
						headers: { "Content-Type": "application/json" },
						body: JSON.stringify({ items: combinedItems }),
					};

					const response = await fetch(cartUrl, combinedOptions);

					if (response.ok) {
						window.location.href = `${shopUrl}/cart`;
					} else {
						nextBtn.disabled = false;
						nextBtn.style.cssText =
							"opacity:1;pointer-events:auto;cursor:pointer";
						nextBtn.textContent = originalText;
						alert("Failed to add to cart. Please try again.");
					}
				}
				addToCart(itemsArray, shopifyCartUrl);
			}
		});
	}

	if (prevBtn) {
		prevBtn.addEventListener("click", function (eventClick) {
			eventClick.preventDefault();
			if (current > 1) {
				stepsLines[current - 1].classList.remove("active");
				current -= 1;
				updateSlidePosition();
				scrollToMultiStepContainer();
				totalPages.innerHTML = current + " / " + slidePages.length;
			}
		});
	}
}

metaValues.steps.forEach((step, index) => {
	addEventListeners(step.step_name, index + 1);
});

function handleExtraOptionsPrice(checkbox, optionPrice) {
	const variantPriceCents =
		parseFloat(document.querySelector(".subTotalPrice").textContent) * 100;
	let priceDivs = document.querySelectorAll(".subTotalPrice");

	if (checkbox.checked) {
		priceDivs.forEach((div) => {
			let newPriceCents = variantPriceCents + optionPrice * 100;
			div.innerHTML = (newPriceCents / 100).toFixed(2);
		});
	} else {
		priceDivs.forEach((div) => {
			let newPriceCents = variantPriceCents - optionPrice * 100;
			div.innerHTML = (newPriceCents / 100).toFixed(2);
		});
	}
}

function handleImageSlider() {
	let concatenatedImageName = "";
	if (Object.keys(galleryImageValue).length === 1) {
		concatenatedImageName = Object.values(galleryImageValue)[0].replace(
			/\s/g,
			"",
		);
	} else {
		concatenatedImageName = Object.values(galleryImageValue).reduce(
			(acc, value) => acc.concat(value.replace(/\s/g, "")),
			"",
		);
	}

	const thumbnailImages = document.querySelectorAll(
		".product-gallery__thumbnail",
	);
	if (thumbnailImages) {
		thumbnailImages.forEach((image) => {
			const imageTitle = $(image).attr("data-title");
			if (imageTitle === concatenatedImageName) {
				$(image).trigger("click");
				$(thumbnailImages).removeClass("is-nav-selected");
				$(image).addClass("is-nav-selected");
			}
		});
	}
}

function appendPetNameInput(
	wrapperEl,
	swatchOption,
	name,
	identifier,
	isTextInput,
	isUploader,
) {
	const container = document.createElement("div");
	container.className = "Pet-name-input-conatiner";

	const label = document.createElement("label");
	label.setAttribute("for", "PETNAME");
	label.textContent = "Enter Pet's Name:";

	const input = document.createElement("input");
	input.type = "text";
	input.id = "PETNAME";
	input.placeholder = "Name in Heart";
	input.maxLength = 18;

	input.setAttribute(
		"oninput",
		`handleInputValues(   'Pet_Name',   event,   this,   null,   null, '${name}' , '${identifier}',   ${isTextInput},  ${isUploader} )
        updateCharCounter(this, 18);
        `,
	);

	const smallCharCounter = document.createElement("div");
	smallCharCounter.className = "char-counter";
	smallCharCounter.textContent = "18 characters remaining";

	container.appendChild(label);
	container.appendChild(input);
	container.appendChild(smallCharCounter);

	wrapperEl.appendChild(container);
}

document.addEventListener("DOMContentLoaded", () => {
	document
		.querySelectorAll("input[maxlength], textarea[maxlength]")
		.forEach((el) => {
			updateCharCounter(el, el.maxLength);
		});
});

function updateCharCounter(inputEl, maxLength) {
	const counter = inputEl.parentElement.querySelector(".char-counter");
	if (!counter) return;

	const remaining = maxLength - inputEl.value.length;
	counter.textContent = `${remaining} characters remaining`;
	counter.style.color = remaining <= 3 ? "#ff3b30" : "#6b7280";
}

function handleInputValues(
	value,
	event,
	element,
	checkBoxElement,
	checkBoxValue,
	name,
	identifier,
	isTextInput,
	isUploader,
) {
	let inputValue = event.target.value;
	document.querySelector(`.${value}HiddenInput`).value = inputValue;
	if (checkBoxElement && element) {
		if (element.checked) {
			document.querySelector(`.${value}HiddenInput`).value = checkBoxValue;
			document.querySelector(`#${value}`).style.pointerEvents = "none";
			document.querySelector(`#${value}`).style.opacity = "0.2";
			document.querySelector(`#${value}`).value = "";
		} else {
			document.querySelector(`.${value}HiddenInput`).value = "";
			document.querySelector(`#${value}`).style.pointerEvents = "auto";
			document.querySelector(`#${value}`).style.opacity = "1";
		}
	}

	let formPetName = document.querySelector(".form-field #Pet_Name");
	if (isTextInput) {
		const hiddenInput = document.querySelector(`.${value}HiddenInput`).value;
		if (hiddenInput.trim() === "") {
			formPetName.value = "";
			formPetName.dataset.skipValidation = "false";
			formPetName.style.pointerEvents = "auto";
			formPetName.style.opacity = "1";
		} else {
			formPetName.value = hiddenInput;
			formPetName.style.pointerEvents = "none";
			formPetName.style.opacity = "0.3";
			formPetName.dataset.skipValidation = "true";
		}
		validateCharmHiddenInputs("customcard", "Pet_Name", "form", null, null);
	}
	validateCharmHiddenInputs(name, value, identifier, isTextInput, isUploader);
}

let selectedCharms = [];
function selectPills(
	element,
	charmValue,
	label,
	className,
	index,
	parentIndex,
	isNative,
	identifier,
	charges,
) {
	const jsonData = metaValues.steps[3];
	const dynamicArea = document.getElementById("pillsDynamicArea");
	const previewArea = document.getElementById("selectedPreview");
	let pillHiddenInput;
	let box = document.querySelectorAll(".pills-buttons .pill-btn");

	box.forEach((btn) => {
		btn.style.border = "1px solid #F4F4F4";
	});
	element.style.border = "1px solid black";

	pillHiddenInput = document.querySelector(
		`.${className}HiddenInput_${parentIndex}`,
	);
	pillHiddenInput.value = "";
	pillHiddenInput.value = charmValue;

	if (isNative) {
		updateVariantTitle(className, charmValue);
	}

	if (charges) {
		const variantPriceCents =
			parseFloat(document.querySelector(".subTotalPrice").textContent) * 100;
		let priceDivs = document.querySelectorAll(".subTotalPrice");
		priceDivs.forEach((div) => {
			let newPriceCents = variantPriceCents + charges * 100;
			div.innerHTML = (newPriceCents / 100).toFixed(2);
		});
	}

	const hiddenInputs = document.querySelectorAll(`.${className}HiddenInput`);
	if (hiddenInputs.length > 0) {
		formattedVariant[className] = "";
		hiddenInputs.forEach((input) => {
			formattedVariant[className] = formattedVariant[className]
				? formattedVariant[className] + " / " + input.value
				: input.value;
		});
	}

	if (charmValue == 0) {
		dynamicArea.innerHTML = "";
		previewArea.innerHTML = "";
		selectedCharms = [];
		document.querySelector(`.${className}NextButton`).style.opacity = "1";
		document.querySelector(`.${className}NextButton`).style.pointerEvents =
			"auto";
		handleGalleryImageSlider(className, "0");
		return;
	}

	const charmNote = document.querySelector(".charmNote");
	if (charmNote && charmNote.style.display !== "none") {
		charmNote.style.display = "none";
	}

	if (selectedCharms.length == charmValue) {
		document.querySelector(`.${className}NextButton`).style.opacity = "1";
		document.querySelector(`.${className}NextButton`).style.pointerEvents =
			"auto";
	} else {
		document.querySelector(`.${className}NextButton`).style.opacity = "0.3";
		document.querySelector(`.${className}NextButton`).style.pointerEvents =
			"none";
	}

	if (selectedCharms.length > charmValue) {
		selectedCharms = selectedCharms.slice(0, charmValue);
		updateCharmHiddenInputs();
		updateCharmPreview(charmValue, className);
	}

	document.querySelector(`.${className}NextButton`).style.opacity = "0.3";
	document.querySelector(`.${className}NextButton`).style.pointerEvents =
		"none";

	let charmsData = jsonData.pills[0];
	const tabName = Object.keys(charmsData.tabs)
		.map(
			(tab) =>
				` <button type="button" class="tab-btn" data-tab="${tab}" style="font-size:15px">${tab}</button>`,
		)
		.join("");

	dynamicArea.innerHTML = `<div> <p style = "font-weight: 14px;" class="stepLabel" >Select  Charms: </p> </div>
          <div class = "tab-btn-wrapper">${tabName}</div>`;

	const firstTabBtn = document.querySelector(".tab-btn");
	if (firstTabBtn) {
		firstTabBtn.style.border = "1px solid #5C6AC4";
		firstTabBtn.style.color = "#5C6AC4";
		const firstTab = firstTabBtn.dataset.tab;
		showCharms(charmValue, charmsData.tabs[firstTab], className);
	}
	document.querySelectorAll(".tab-btn").forEach((btn) => {
		btn.addEventListener("click", (tabEvent) => {
			document.querySelectorAll(".tab-btn").forEach((b) => {
				b.style.border = "1px solid #F4F4F4";
				b.style.color = "#000000";
			});
			tabEvent.target.style.border = "1px solid #5C6AC4";
			tabEvent.target.style.color = "#5C6AC4";
			const tab = btn.dataset.tab;
			showCharms(charmValue, charmsData.tabs[tab], className);
		});
	});

	handleGalleryImageSlider(className, charmValue);
	if (selectedCharms.length == charmValue) {
		document.querySelector(`.${className}NextButton`).style.opacity = "1";
		document.querySelector(`.${className}NextButton`).style.pointerEvents =
			"auto";
	} else {
		document.querySelector(`.${className}NextButton`).style.opacity = "0.3";
		document.querySelector(`.${className}NextButton`).style.pointerEvents =
			"none";
	}
}

function showCharms(maxCharms, charmData, className) {
	const previewArea = document.getElementById("selectedPreview");
	const charms = charmData
		.map((option, index) => {
			const isActive = selectedCharms.some((c) => c.name === option.name);
			const imgSrc =
				currentFinish.includes("silver") && option.img_2
					? option.img_2
					: option.img;
			return `
          <div class="charmOption ${isActive ? "active-charm" : ""}" 
              data-index="${index}" 
              data-charmName="${option.name}" 
              data-charmImg="${imgSrc}"
              data-charmId="${option.id}">
            <img src="${imgSrc}" 
                 data-image-gold="${option.img}" 
                 ${option.img_2 ? `data-image-silver="${option.img_2}"` : ""} 
                 style="width:100%; height:100%; object-fit:cover;">
          </div>`;
		})
		.join("");
	let charmsListContainer = previewArea.querySelector(".selected-charms-list");
	if (!charmsListContainer) {
		charmsListContainer = document.createElement("div");
		charmsListContainer.className = "selected-charms-list";
		previewArea.appendChild(charmsListContainer);
	}
	charmsListContainer.innerHTML = charms;
	previewArea.style.display = "block";

	document.querySelectorAll(".charmOption").forEach((div) => {
		div.addEventListener("click", () => {
			selectCharms(div, maxCharms, className);
		});
	});
}

function selectCharms(element, maxSelect, className) {
	const charmName = element.dataset.charmname;
	const charmImg = element.dataset.charmimg;
	const charmId = element.dataset.charmid;

	if (selectedCharms.some((c) => c.name === charmName)) {
		selectedCharms = selectedCharms.filter((c) => c.name !== charmName);
		element.classList.remove("active-charm");
	} else {
		if (selectedCharms.length >= maxSelect) {
			alert(`You can only select ${maxSelect} charms.`);
			return;
		}
		selectedCharms.push({ name: charmName, img: charmImg, id: charmId });
		element.classList.add("active-charm");
	}

	updateCharmHiddenInputs();
	updateCharmPreview(maxSelect, className);

	if (selectedCharms.length == maxSelect) {
		document.querySelector(`.${className}NextButton`).style.opacity = "1";
		document.querySelector(`.${className}NextButton`).style.pointerEvents =
			"auto";
	} else {
		document.querySelector(`.${className}NextButton`).style.opacity = "0.3";
		document.querySelector(`.${className}NextButton`).style.pointerEvents =
			"none";
	}
}

function updateCharmHiddenInputs() {
	document.querySelectorAll(".charm-hidden").forEach((el) => el.remove());
	const container = document.getElementById("selectedPreview");

	selectedCharms.forEach((charm, index) => {
		let input = document.createElement("input");
		input.type = "hidden";
		input.className = "charm-hidden";
		input.name = `properties[charm_${index + 1}]`;
		input.value = charm.name;
		container.appendChild(input);
	});
}

function updateCharmPreview(maxSelect, className) {
	document
		.querySelectorAll(".wrapper-active-selected-charms")
		.forEach((el) => el.remove());

	const parent = document.getElementById("selectedPreview");
	let container = document.createElement("div");
	container.className = "wrapper-active-selected-charms";

	let label = document.createElement("label");
	label.className = "active-selected-charms";
	label.innerHTML = `${selectedCharms.length} Charm${selectedCharms.length > 1 ? "s" : ""} Selected`;

	let charmsWrapper = document.createElement("div");
	charmsWrapper.className = " charmOption_wrapper ";
	if (selectedCharms.length > 0) {
		container.appendChild(label);
		selectedCharms.forEach((charm) => {
			let charmSelectedOptionItem = document.createElement("div");
			charmSelectedOptionItem.className = "charmSelectedOptionItem";
			charmSelectedOptionItem.style.width = "100px";

			let imgDiv = document.createElement("div");
			imgDiv.className = "charmOption";
			imgDiv.style.position = "relative";

			let name = document.createElement("span");
			name.className = "charm-name";
			name.textContent = charm.name;

			let img = document.createElement("img");
			img.src = charm.img;
			img.style.width = "100%";
			img.style.height = "100%";
			img.style.objectFit = "cover";

			const option = findCharmInMeta(charm.name);
			if (option) {
				img.dataset.imageGold = option.img;
				if (option.img_2) img.dataset.imageSilver = option.img_2;
			}

			let removeBtn = document.createElement("button");
			removeBtn.innerHTML = "×";
			removeBtn.className = "charm-remove-btn";
			removeBtn.type = "button";

			removeBtn.addEventListener("click", (removeEvent) => {
				removeEvent.stopPropagation();
				removeCharmFromPreview(charm.name, maxSelect, className);
			});

			imgDiv.appendChild(img);
			imgDiv.appendChild(removeBtn);
			charmSelectedOptionItem.appendChild(imgDiv);
			charmSelectedOptionItem.appendChild(name);
			charmsWrapper.appendChild(charmSelectedOptionItem);
		});
		container.appendChild(charmsWrapper);
		parent.appendChild(container);
	}
}

function removeCharmFromPreview(charmName, maxSelect, className) {
	selectedCharms = selectedCharms.filter((c) => c.name !== charmName);

	document
		.querySelectorAll(".selected-charms-list .charmOption")
		.forEach((div) => {
			if (div.dataset.charmname === charmName) {
				div.classList.remove("active-charm");
			}
		});

	updateCharmHiddenInputs();
	updateCharmPreview(maxSelect, className);
	if (selectedCharms.length == maxSelect) {
		document.querySelector(`.${className}NextButton`).style.opacity = "1";
		document.querySelector(`.${className}NextButton`).style.pointerEvents =
			"auto";
	} else {
		document.querySelector(`.${className}NextButton`).style.opacity = "0.3";
		document.querySelector(`.${className}NextButton`).style.pointerEvents =
			"none";
	}
}

function validateCharmHiddenInputs(
	optionName,
	optionValue,
	identifierName,
	isTextInput,
	isUploader,
) {
	const nextButton = document.querySelector(`.${optionName}NextButton`);
	const hiddenInput = document.querySelector(`.${optionName}HiddenInput`);
	const uploaderHiddenInput = document.querySelector(".hiddenInputSimple-1");

	let isValid = true;

	if (identifierName !== "form") {
		if (!hiddenInput || hiddenInput.value.trim() === "") {
			isValid = false;
		}
	}

	if (isUploader) {
		if (!uploaderHiddenInput || uploaderHiddenInput.value.trim() === "") {
			isValid = false;
		}
	}

	if (isTextInput) {
		const textHiddenInput = document.querySelector(
			`.${optionValue}HiddenInput`,
		);
		if (!textHiddenInput || textHiddenInput.value.trim() === "") {
			isValid = false;
		}
	}

	if (identifierName == "form") {
		const formHiddenInputs = document.querySelectorAll(
			".charmForm-Wrapper input[type='hidden']",
		);

		for (const input of formHiddenInputs) {
			const fieldName = input.className.replace("HiddenInput", "");
			const visibleInput = document.querySelector(`#${fieldName}`);

			if (visibleInput?.dataset.skipValidation === "true") {
				continue;
			}

			if (input.value.trim() === "") {
				isValid = false;
				break;
			}
		}
	}

	nextButton.style.pointerEvents = isValid ? "auto" : "none";
	nextButton.style.opacity = isValid ? "1" : "0.3";
}

function renderChramOptionOnLoad(element, tabName) {
	const jsonData = metaValues.steps[3];
	const charmsData = jsonData.pills[0];
	const tabs = charmsData.tabs;

	const container = document.querySelector(".selected-charms-list");
	container.innerHTML = "";

	document.querySelectorAll(".tab-btn").forEach((btn) => {
		btn.style.border = "none";
		btn.style.color = "#000000";
	});
	if (element) {
		element.style.border = "1px solid #5461C8";
		element.style.color = "#5461C8";
	}

	const items = tabs[tabName];
	if (!items) return;

	items.forEach((item, index) => {
		const div = document.createElement("div");
		div.className = "charmOption ";
		div.dataset.tab = tabName;
		div.dataset.index = index;
		div.dataset.charmname = item.name;
		div.dataset.charmimg = item.img;

		const imgSrc =
			currentFinish.includes("silver") && item.img_2 ? item.img_2 : item.img;

		div.innerHTML = `
      <img src="${imgSrc}" 
           alt="${item.name}" 
           data-image-gold="${item.img}" 
           ${item.img_2 ? `data-image-silver="${item.img_2}"` : ""} 
           style="width:100%; height:100%; object-fit:cover;">
    `;

		container.appendChild(div);
	});
}

document.addEventListener("DOMContentLoaded", () => {
	const firstTabBtn = document.querySelector(".tab-btn");
	if (!firstTabBtn) return;
	const firstTab = firstTabBtn.dataset.tab;
	renderChramOptionOnLoad(firstTabBtn, firstTab);
});

function appendPhotoGuide() {
	const container = document.querySelector(".photoGuideContainerMobile");
	if (!container) return;
	container.innerHTML = "";
	container.style.margin = "30px 0px";
	container.innerHTML = `
      <img src="${photoGuideAssetUrl}" alt="Photo Guide">
      <span class="photoGuide">Photo Guide</span>
  `;
	container.addEventListener("click", handlePhotoGuidePopup);
}

function handlePhotoGuidePopup() {
	const popupContainer = document.querySelector(".popup-photo-guide-container");
	if (popupContainer.style.display === "none") {
		popupContainer.style.display = "block";
	} else {
		popupContainer.style.display = "none";
	}
}

function closePhotoGuidePopup() {
	const popupContainer = document.querySelector(".popup-photo-guide-container");
	popupContainer.style.display = "none";
}

// Expose handlers used by inline attributes in Liquid markup.
window.selectSwatch = selectSwatch;
window.selectPills = selectPills;
window.renderChramOptionOnLoad = renderChramOptionOnLoad;
window.handleExtraOptionsPrice = handleExtraOptionsPrice;
window.handlePhotoGuidePopup = handlePhotoGuidePopup;
window.closePhotoGuidePopup = closePhotoGuidePopup;
window.portraitDragNdrop = portraitDragNdrop;
window.drag = drag;
window.drop = drop;

document.addEventListener(
	"dragover",
	function (e) {
		const target = e.target.closest(".image-uploader");
		if (target) target.classList.add("dragover");
	},
	false,
);

document.addEventListener(
	"dragleave",
	function (e) {
		const target = e.target.closest(".image-uploader");
		if (target) target.classList.remove("dragover");
	},
	false,
);

document.addEventListener(
	"drop",
	function (e) {
		const target = e.target.closest(".image-uploader");
		if (target) target.classList.remove("dragover");
	},
	false,
);

// Backward-compatible aliases for existing Liquid onclick names.
window.handleSizeChartPopup = handlePhotoGuidePopup;
window.closeSizeChartPopup = closePhotoGuidePopup;
